import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { VelvetSDK } from 'sdk'
import { useTypedSelector } from 'store'

const ProtectedAuthRoutes = () => {
  const navigate = useNavigate()
  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const initialRoute = useTypedSelector((state) => state.menu.initialRoute)
  const menuData = useTypedSelector((state) => state.menu.data.mainMenu)

  const handleLoginSuccess = useCallback(() => {
    initialRoute && menuData.content.length > 1 && navigate(initialRoute)
  }, [initialRoute, menuData.content.length, navigate])

  const handleLoginError = useCallback(() => setIsLoggedIn(false), [])

  const checkUser = useCallback(async () => {
    try {
      const tokens = await VelvetSDK.TokenManager.service.getTokens()
      tokens ? handleLoginSuccess() : handleLoginError()
    } catch (error) {
      handleLoginError()
    }
  }, [handleLoginError, handleLoginSuccess])

  useEffect(() => {
    checkUser()
  }, [checkUser])

  return <>{isLoggedIn ? null : <Outlet />}</>
}

export default ProtectedAuthRoutes
